// extracted by mini-css-extract-plugin
module.exports = {"container":"Tabs_container__s7UYm","header":"Tabs_header__ENuIE","titleContainer":"Tabs_titleContainer__VlDsW","loadingContainer":"Tabs_loadingContainer__Ewtc2"};